<template>
  <div>


    <!-- @TODO kyc , kyb 메뉴 분기처리 -->
    <ul class="menu-nav" v-show="isShowMenu">

      <!--
      <router-link to="/dashboard/project-list" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> Project List </span>
          </a>
        </li>
      </router-link>
      -->

      <router-link
          to="/dashboard/dashboard"
          v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> {{ $t("Dashboard") }} </span>
          </a>
        </li>
      </router-link>


      <router-link
          to="/dashboard/kyb-main"
          v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> {{ $t("KYBData") }} </span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/activity-history" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> {{ $t("KYBActivityLog") }} </span>
          </a>
        </li>
      </router-link>

      <!--
      <router-link
        to="/builder"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> KYB History </span>
          </a>
        </li>
      </router-link>
      -->
    </ul>

    <ul class="menu-nav" v-show="isShowKycMenu">
      <router-link to="/dashboard/kyc-main" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{ $t("Dashboard") }}</span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/kyc-submissions" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{ $t("GNBSubmissions") }}</span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/kyc-aml-reports" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{ $t("AMLReports") }}</span>
            <b-button variant="primary" size="sm" class="mx-2 my-1" v-if="selectedProjectObject.isUseAml">ON</b-button>
            <b-button variant="danger" size="sm" class="mx-2 my-1" v-if="!selectedProjectObject.isUseAml">OFF</b-button>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/kyc-event-logs" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{ $t("Events") }}</span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/kyc-setting" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{ $t("Setting") }}</span>
          </a>
        </li>
      </router-link>

      <router-link to="/dashboard/kyc-add-on-list" v-slot="{ href, navigate, isActive, isExactActive }">
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text">{{$t("AddOn")}}</span>
          </a>
        </li>
      </router-link>


      <!--
      <router-link
        to="/builder"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active'
          ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <span class="menu-text"> KYB History </span>
          </a>
        </li>
      </router-link>
      -->
    </ul>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  },

  mounted() {

  },

  computed : {
    ...mapGetters( {
      selectedProjectObject : "getSelectedProjectObject"
    } ),

    isShowMenu() {
      return this.selectedProjectObject.type == "KYB"
    },

    isShowKycMenu(){
      return this.selectedProjectObject.type == "KYC"
    },

  }
};
</script>
